module.exports = __webpack_public_path__ + "static/media/s68.9dc0ba60.jpg";